const PreSaleCommPlanStatistic = () => import('@/views/main/report/preSaleCommPlan/PreSaleCommPlanStatistic.vue')
export default {
  path: '/main/report/preSaleCommPlanStatistic',
  name: 'preSaleCommPlanStatistic',
  component: PreSaleCommPlanStatistic,
  children: []
}
